import { styled, TextField, Typography } from '@ori-ui/mui';

const AnchorResend = styled('a')(({ theme }) => ({
  textDecoration: 'underline',
  cursor: 'pointer',
  '&:hover': {
    color: theme.palette.primary.dark,
  },
}));

const StyledTextField = styled(TextField)({
  '& input': {
    textAlign: 'center',
  },
  margin: '0 5px',
  width: '50px',
  maxWidth: '100%',
  textAlign: 'center',
});

const RootContainer = styled('div')(({ theme }) => ({
  maxWidth: '360px',
  marginTop: theme.spacing(10),
}));

const ResendText = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(8),
}));

const CodeDiv = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
});

export { AnchorResend, StyledTextField, RootContainer, CodeDiv, ResendText };
